import React from "react";
import "../../../../../Assets/Styles/IconSwitch.scss";
import ImagePreloader from "../ImagePreloader/ImagePreloader";
import Lock from "../../../../../Assets/Images/JPA Icons/lock.svg";
import Check from "../../../../../Assets/Images/JPA Icons/Check.svg";

const IconSwitch = (props) => {
  const handleSwitch = () => {
    if (
      document
        .getElementById(props.Id + "-icon-switch")
        .classList.contains("icon-switch-wrapper-active")
    ) {
      document
        .getElementById(props.Id + "-icon-switch")
        .classList.remove("icon-switch-wrapper-active");
    } else {
      document
        .getElementById(props.Id + "-icon-switch")
        .classList.add("icon-switch-wrapper-active");
    }
    if (props.ChangeEvent) {
      props.ChangeEvent();
    }
  };
  return (
    <React.Fragment>
      <ImagePreloader Images={[Lock, Check]} />
      <div
        className={
          props.IsActive
            ? "icon-switch-wrapper icon-switch-wrapper-active"
            : "icon-switch-wrapper"
        }
        id={props.Id + "-icon-switch"}
      >
        <section className="switch-rail">
          <span className="switch-circle" onClick={() => handleSwitch()}></span>
        </section>
      </div>
    </React.Fragment>
  );
};

export default IconSwitch;
